var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('notification',{attrs:{"type":"is-success","icon":"fa-check","snackbar":_vm.snackbar},on:{"delete":function($event){return _vm.$emit('delete')}}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.content)}})])}
var staticRenderFns = []

export { render, staticRenderFns }